<template>
  <v-container fluid pa-0 ma-0>
    <v-layout row wrap class="ma-0">

      <v-toolbar class="pa-0 ma-0 toolbar-padding" :class="{ 'toolbar-shadow': scrollY === 0 }"
                 color="white" flat dense fixed app>
        <v-btn small flat icon @click="$router.go(-1)">
          <v-icon size="24px">$vuetify.icons.navArrowLeft</v-icon>
        </v-btn>
        <h3 class="display-2" style="margin-bottom: 2px">프로필 수정</h3>
        <v-spacer></v-spacer>
        <v-btn icon @click="save" :loading="loading" :disabled="loading">저장</v-btn>
      </v-toolbar>

      <v-flex xs12>
        <v-card tile class="pt-4 mt-2 card-shadow">
          <v-layout row wrap>
            <v-flex xs12>
              <v-avatar size="84px">
                <v-img v-if="changedProfileImage" :src="changedProfileImage.url"></v-img>
                <v-img v-else :src="profileImageSrc" :lazy-src="require('@/assets/img/profile-default.png')" @error="isProfileLoaded = false"></v-img>
                <input ref="profileImageUpload" name="img-uploads" type="file" accept="image/*" @change="onFileChanged" style="display: none;">
                <v-btn icon dark color="black" absolute class="profile-change-button" @click="$refs.profileImageUpload.click()">
                  <v-icon size="22px" style="margin-top: -2px; margin-left: 1px;">$vuetify.icons.camera</v-icon>
                </v-btn>
              </v-avatar>
            </v-flex>
            <v-divider class="mx-4 my-3"></v-divider>
            <v-flex xs12 class="d-flex text-xs-left align-center" style="height: 48px; padding-left: 20px; padding-right: 20px;">
              <label for="email" class="body-2" style="flex-grow: 0 !important; flex-shrink: 0 !important; margin-right: 21px;">이메일</label>
              <input id="email" class="body-2" placeholder="이메일" v-model="changedEmail" :disabled="!!email">
            </v-flex>
            <v-flex xs12 class="d-flex text-xs-left align-center" style="height: 48px; padding-left: 20px; padding-right: 20px;">
              <label for="name" class="body-2" style="flex-grow: 0 !important; flex-shrink: 0 !important; margin-right: 21px;">닉네임</label>
              <input id="name" class="body-2" style="caret-color: #ec2f54; outline: none;" placeholder="닉네임" v-model="changedName">
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>

      <!-- 임시 스낵바 -->
      <v-snackbar v-model="snackbar" bottom vertical :timeout="3000" auto-height>
        {{ snackbarMessage }}
        <v-btn color="primary" flat @click="snackbar = false">닫기</v-btn>
      </v-snackbar>

    </v-layout>
  </v-container>
</template>

<script>
  import EXIF from 'exif-js';
  import { mapGetters, mapActions } from 'vuex';

  export default {
    name: 'Profile',
    computed: {
      ...mapGetters('user', [ 'email', 'name', 'profile_image' ]),
      profileImageSrc () {
        return this.profile_image && this.isProfileLoaded ? `${this.$storage}/user/profile/${this.profile_image}` : require('@/assets/img/profile-default.png');
      }
    },
    data () {
      return {
        loading: false,
        scrollY: 0,
        isProfileLoaded: true,
        changedProfileImage: null,
        changedName: '',
        changedEmail: '',
        snackbarMessage: '',
        snackbar: false,
      };
    },
    created () {
      window.addEventListener('scroll', this.getScrollY);
      this.changedName = this.name;
      this.changedEmail = this.email;
    },
    destroyed () {
      window.removeEventListener('scroll', this.getScrollY);
    },
    methods: {
      ...mapActions('user', [ 'setUser', 'setJWT', 'updateUser' ]),
      getScrollY () {
        this.scrollY = window.scrollY;
      },
      onFileChanged (event) {
        let file = event.target.files[0];
        if (/^image\//i.test(file.type)) this.readFile(file);
      },
      // image file read & process
      readFile (file) {
        let reader = new FileReader();
        let root = this;
        reader.onloadend = function () {
          root.processFile(reader.result, file.type);
        };
        reader.onerror = function () {
          // alert('error');
          // root.showModal({ flag: true, which: `Alert#${root.$t('error')}` });
        };
        reader.readAsDataURL(file);
      },
      processFile (dataURL, fileType) {
        // TODO: EXIF extract and orient the image
        let maxWidth = 200;
        let maxHeight = 200;
        let image = new Image();
        image.src = dataURL;
        let root = this;
        image.onload = function () {
          let width = image.width;
          let height = image.height;
          let shouldResize = (width > maxWidth) || (height > maxHeight);
          if (!shouldResize) {
            root.appendFile(dataURL);
            return;
          }
          let sx = 0;
          let sy = 0;
          let sWidth = image.width;
          let sHeight = image.height;
          if (width > height) {
            sx = width / 2 - height / 2;
            sWidth = sHeight;
          } else if (width < height) {
            sy = height / 2 - width / 2;
            sHeight = sWidth;
          }
          let canvas = document.createElement('canvas');
          canvas.width = 200;
          canvas.height = 200;
          let context = canvas.getContext('2d');
          EXIF.getData(image, () => {
            const tags = EXIF.getAllTags(image);
            console.log(tags);
            root.transformCoordinates(canvas, tags);
          });
          context.drawImage(this, sx, sy, sWidth, sHeight, 0, 0, 200, 200);
          dataURL = canvas.toDataURL(fileType);
          root.appendFile(dataURL);
        };
        image.onerror = function () {
          // alert('error');
          // root.showModal({ flag: true, which: `Alert#${root.$t('shared')}` });
        };
      },
      appendFile (dataURL) {
        let blob = this.dataURItoBlob(dataURL);
        this.changedProfileImage = { url: dataURL, file: blob };
      },
      dataURItoBlob (dataURI) {
        let byteString = atob(dataURI.split(',')[1]);
        // separate out the mime component
        let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        // write the bytes of the string to an ArrayBuffer
        let ab = new ArrayBuffer(byteString.length);
        let ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeString });
      },
      transformCoordinates (canvas, options) {
        let ctx = canvas.getContext('2d');
        let width = canvas.width;
        let height = canvas.height;
        let styleWidth = canvas.style.width;
        let styleHeight = canvas.style.height;
        let orientation = options.Orientation;
        console.log(orientation);
        if (!orientation || orientation > 8) {
          return;
        }
        if (orientation > 4) {
          canvas.width = height;
          canvas.height = width;
          canvas.style.width = styleHeight;
          canvas.style.height = styleWidth;
        }
        switch (orientation) {
          case 2:
            // horizontal flip
            ctx.translate(width, 0);
            ctx.scale(-1, 1);
            break;
          case 3:
            // 180° rotate left
            ctx.translate(width, height);
            ctx.rotate(Math.PI);
            break;
          case 4:
            // vertical flip
            ctx.translate(0, height);
            ctx.scale(1, -1);
            break;
          case 5:
            // vertical flip + 90 rotate right
            ctx.rotate(0.5 * Math.PI);
            ctx.scale(1, -1);
            break;
          case 6:
            // 90° rotate right
            ctx.rotate(0.5 * Math.PI);
            ctx.translate(0, -height);
            break;
          case 7:
            // horizontal flip + 90 rotate right
            ctx.rotate(0.5 * Math.PI);
            ctx.translate(width, -height);
            ctx.scale(-1, 1);
            break;
          case 8:
            // 90° rotate left
            ctx.rotate(-0.5 * Math.PI);
            ctx.translate(-width, 0);
            break;
        }
      },
      // end
      save () {
        this.loading = true;
        let user = {
          name: null,
          email: null,
        };
        if (this.name !== this.changedName) user.name = this.changedName;
        if (!this.email && this.changedEmail) user.email = this.changedEmail;
        if (user.name || user.email || this.changedProfileImage) {
          let formData = new FormData();
          if (user.name) formData.append('name', user.name);
          if (user.email) formData.append('email', user.email);
          if (this.changedProfileImage) {
            formData.append('files', this.changedProfileImage.file);
            // formData.append('deleted', this.profile_image);
          }
          this.updateUser(formData).then(response => {
            this.setUser(response.data);
            this.setJWT(response.data.token);
            this.showSnackbar('저장되었습니다.');
          }).catch(err => {
            console.error(err);
            this.showSnackbar('오류가 발생했습니다. 잠시 후 다시 시도해 보세요.');
          }).finally(() => {
            this.loading = false;
          });
        }
      },
      showSnackbar (message) {
        this.snackbarMessage = message;
        this.snackbar = true;
      },
    }
  }
</script>

<style lang="scss" scoped>
  /deep/.toolbar-shadow .v-toolbar__content {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  /deep/.toolbar-padding .v-toolbar__content {
    padding: 0 10px 0 16px;
  }

  /deep/.card-shadow {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  .profile-change-button {
    width: 24px !important;
    height: 24px;
    right: 0;
    bottom: 0;
  }

  input {
    border-radius: 5px;
    padding: 6px 8px;
    background-color: map_get($colors, background);
    &[disabled] {
      background-color: transparent;
      font-size: 14px;
      font-weight: 700;
      letter-spacing: -0.2px;
      color: black;
      opacity: 1;
    }
  }
</style>
